<template>
  <div class="project-edit">
    <navigation>
      <rum-select
        class="project__select"
        placeholder="Select a Project"
        :value="project"
        :options="projects"
        :clearable="false"
        :get-option-label="getOptionLabel"
        @input="onProjectChange"
      />
      <span style="display: flex; min-width: 220px;">
        <span class="deploy__app" @click="deployApp">
          <i class="far fa-bolt"></i>
          <span class="mobile__text">
            Deploy App
          </span>
        </span>
        <span class="deploy__app" style="margin-top: 2px;" @click="openCopyCodeModal">
          <i class="far fa-code"></i>
          <span class="mobile__text">
            Embed
          </span>
        </span>
      </span>
    </navigation>
    <rum-loader full center v-if="loading" style="height: 100%;"/>
		<project-steps :active="activeStep" @next="onStepNext" @prev="onStepPrev" @change="onStepChange" :project="project" />

		<project-manage-details v-show="activeStep === 1" @currentProject="currentProject" ref="content"></project-manage-details>
    <project-learning-content v-show="activeStep === 2"  ref="content"></project-learning-content>
		<manage-channels v-show="activeStep === 3" :project="project" ref="content"></manage-channels>
    <deploy-app-modal />
    <search-copy-code-modal v-show="project.language" :projectLanguage="projectLanguage" />
  </div>
</template>

<script>
import api from "@/api";
import Navigation from "@/components/Navigation";
import ProjectSteps from "@/components/ProjectConnect/ProjectSteps";
import ProjectManageDetails from "@/components/ProjectConnect/ProjectManageDetails";
import ProjectLearningContent from "@/components/ProjectConnect/ProjectLearningContent";
import ManageChannels from "@/components/ProjectConnect/ManageChannels";
import DeployAppModal from "@/components/ProjectConnect/DeployAppModal";
import SearchCopyCodeModal from '../components/ProjectConnect/SearchCopyCodeModal.vue';

export default {
  name: "ProjectConnect",
  components: {
		Navigation,
		ProjectSteps,
		ProjectManageDetails,
    ManageChannels,
    ProjectLearningContent,
    DeployAppModal,
    SearchCopyCodeModal
  },
  data() {
		return {
			activeStep: 1,
      loading: false,
      project: {},
      projects: [],
      projectLanguage: "eng"
		}
  },
  computed: {
    organizationId() {
      return this.$store.getters.administeredOrganizationId;
    },
    projectId() {
      return this.$route.params.id;
    }
  },
	methods: {
    openCopyCodeModal() {
      this.$modal.show("search-copy-code-modal");
    },
    deployApp() {
      this.$modal.show("deploy-app-modal", { project: this.project });
    },
    getOptionLabel (option) {
      return (option && option.name) || ''
    },
    onProjectChange(project) {
      if (!project || project.id === this.projectId) return;

      this.$router.push({
        name: "ProjectConnect",
        params: {id: project.id}
      });
    },
    onStepChange(step) {
      this.activeStep = step;
    },
    onStepNext() {
      this.activeStep = Math.min(3, this.activeStep + 1);
    },
    onStepPrev() {
      this.activeStep = Math.max(0, this.activeStep - 1);
    },
    currentProject(data) {
      this.project = data;
      this.projectLanguage = this.project.language && this.project.language.value;
      this.$store.dispatch("projectEdit/setCurrentProjectName", this.project.name);
    },
    async fetchOrganizationsProject() {
      const current = api('v3');
      const { data } = await current.get(`connect/organizations/${this.organizationId}/projects`);
      this.projects = data.projects || [];
    },
  },
  watch: {
    organizationId: {
      immediate: true,
      handler() {
        if(this.organizationId) {
          this.fetchOrganizationsProject();
        }
      }
    }
  }
};
</script>

<style scoped>
.project__edit {
  color: var(--primary);
  text-decoration: none;
  font-weight: bold;
  min-width: 100px;
}

.project__action {
  cursor: pointer;
  margin-left: var(--spacing-4);
  margin-right: var(--spacing-2);
}

.project__action:hover {
  transform: scale(1.1);
}

.project__select {
  width: 45%;
  margin-left: var(--spacing-4);
}

.deploy__app {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  color: var(--primary);
  cursor: pointer;
  background: none;
  border: none;
  text-decoration: none;
  font-weight: bold;
  margin-left: var(--spacing-4);
}
.far {
  margin-right: 5px;
}

@media screen and (max-width: 650px) {
  .project-edit__text {
    display: none;
  }
}

@media screen and (max-width: 650px) {
  .project__select {
    display: none;
  }

  .project__edit {
    display: none;
  }

  .deploy__app {
    margin-left: auto;
  }

  .mobile__text {
    font-size: 14px;
  }
}
</style>
